/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllCoachingBookingList } from "../../redux/Slice/CoachingBooking/CoachingBookingListSlice";
import { format } from "date-fns";
import InputIcon from "react-multi-date-picker/components/input_icon";
import DatePicker from "react-multi-date-picker";
import { toast } from "react-toastify";

const CustomerCoachingBookingList = (props: any) => {
  const { situationType } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    AllCoachBookingData = [],
    currentPage,
    rowsPerPage,
    totalPage,
    totalRows,
    errorMessage
  } = useAppSelector((state) => state?.coachBooking);

  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState<any>("");
  const [toDate, setToDate] = useState<any>("");
  const [sorting, setSorting] = useState({ column: "", order: "" });
  const [isMounted, setIsMounted] = useState(false);

  const columns = [
    {
      Header: "Sr No.",
      accessor: "srNo",
    },
    {
      Header: "Facility Name",
      accessor: "facilityName",
    },
    {
      Header: "Sport Name",
      accessor: "sportName",
    },
    {
      Header: "Session Name",
      accessor: "sessionName",
    },
    {
      Header: "Enrolled Session",
      accessor: "noOfSessionToAttend",
    },
    {
      Header: "Remaining Session",
      accessor: "remainingSessions",
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "End Date",
      accessor: "endDate",
    },
    {
      Header: "Booking Status",
      accessor: "bookingStatus",
    },
    {
      Header: "Amount",
      accessor: "totalAmount",
    },
  ];
  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  const orderColComing = ["sportName", "startDate", "endDate", "facilityName"];

  const orderColSend = ["sport", "startDate", "endDate", "facility"];

  const orderByColumn = (column: string) => {
    if (orderColComing.includes(column))
      return orderColSend[orderColComing.indexOf(column)];
    else return "";
  };
  const orderCol = orderByColumn(sorting.column);

  useEffect(() => {
    if (!key && !fromDate && !toDate) {
      dispatch(
        AllCoachingBookingList({ page: "1", situationType: situationType })
      );
    }
  }, [key, fromDate, toDate]);

  useEffect(() => {
    if (isMounted) {
      handleSearch();
    } else {
      setIsMounted(true);
    }
  }, [sorting]);

  const NextPage = (page: string) => {
    handleSearch(page);
  };

  const PreviousPage = (page: string) => {
    handleSearch(page);
  };

  const handleCoachingBookingInfo = (row: any) => {
    situationType === "current"
      ? navigate(`/coaching-session-booking-detail/${row.id}`)
      : handlePrint(row.id);
  };

  const handleSearch = (page: any = "") => {
    dispatch(
      AllCoachingBookingList({
        page: !page || typeof page === "object" ? "1" : page,
        keyword: key,
        fromDate: fromDate ? format(fromDate, "yyyy-MM-dd") : "",
        toDate: toDate ? format(toDate, "yyyy-MM-dd") : "",
        orderByCol: orderCol,
        orderBy: sorting.order,
        situationType: situationType,
      })
    );
  };

  const handleFromDate = (e: any) => {
    setFromDate(e?.toDate());
  };

  const handleToDate = (e: any) => {
    setToDate(e?.toDate());
  };

  const handleClear = () => {
    setKey("");
    setFromDate("");
    setToDate("");
    setSorting({ column: "", order: "" });
  };

  const handlePrint = async (id: string) => {
    let invoiceGet: any = AllCoachBookingData.find((item) => item.id == id);

    window.open("/printing/?type=invoice&prefix=SB&id=" + id + "&hash=" + invoiceGet.hash, "_blank");
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">
              Coaching Session Booking List
            </Card.Title>
          </div>
          <Row className="row-mb">
            <Col lg={6}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={6} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                />
                <Button
                  onClick={handleSearch}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {(fromDate || toDate || key) && (
                <div
                  onClick={handleClear}
                  className="btn btn-link position-absolute top-0"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              )}
            </Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={columns}
            data={AllCoachBookingData}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalRows={totalRows}
            totalPage={totalPage}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            onRowClick={handleCoachingBookingInfo}
            hideActionCol={true}
            show={true}
            isSorting={true}
            sorting={sorting}
            setSorting={setSorting}
            orderColComing={orderColComing}
            hideEditAction={true}
            hideViewAction={true}
            hideDeleteAction={true}
          />
        </div>
      </Card>
    </>
  );
};

export { CustomerCoachingBookingList };
